<script>
  import { Doughnut, mixins } from 'vue-chartjs'
  const { reactiveData } = mixins

  export default {
    extends: Doughnut,
    mixins: [reactiveData],
    props: ['data'],
    mounted () {
      this.renderChart(this.chartData, this.options)
    },
    watch: {
      data: function (newData, oldData) {
        this.chartData = newData.report
        this.options = newData.options
      }
    }
  }
</script>



// WEBPACK FOOTER //
// DoughnutChart.vue?5f328803